import React, {FunctionComponent, SVGProps} from "react";
import {ReactComponent as IconWarning} from "../../../assets/icons/icon_popup_warning_new_version.svg"
import {ReactComponent as IconInfo} from "../../../assets/icons/info_white_rounded.svg"
import {ReactComponent as IconSuccess} from "../../../assets/icons/success-rounded-white.svg"

import {Employee, Payroll} from "../../../app/interfaces";
import {
    EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED,
    EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED,
    EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE, EMPLOYMENT_STATUS_PENDING_REGISTRATION_PAYMENT,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT
} from "../../../utils/constants";
import {useTranslation} from "react-i18next";
import {ImportantMessagesContainer } from "./styles";
import ResendSignatureEmail from "./components/ResendSignatureEmail";
import {SecondaryButton} from "../../../components";

interface ImportantMessageProps {
    employee: Employee,
    currentMonthPayroll?: Payroll
    onCancelEorRequest? : () => void
}

const ImportantMessage = ({employee, currentMonthPayroll, onCancelEorRequest}:ImportantMessageProps) => {
    const {t} = useTranslation()

    let Icon:FunctionComponent<SVGProps<SVGSVGElement>> = IconInfo;
    let title: string;
    let message: string;
    let buttonLabel: string | null = null;
    let buttonHandler: (() => void) | null = null;

    if(employee.status === EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED){
        title = t(EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED)
        message = t('quote_under_review_message')
        Icon = IconWarning
        buttonLabel = t('cancel_quote_request');
        buttonHandler = onCancelEorRequest ?? null;
    }else if(employee.status === EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED) {
        title = t(EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED)
        message = t('quote_approved_message')
        Icon = IconSuccess
    }else if(employee.status === EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE){
        title = t(EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE)
        message = t('awaiting_employee_signature_message')
        Icon = IconWarning
    }else if(
        employee.status === EMPLOYMENT_STATUS_PENDING_REGISTRATION_PAYMENT &&
        currentMonthPayroll &&
        currentMonthPayroll.status === PAYROLL_STATUS_PENDING_COMPANY_PAYMENT
    ){
        title = t('awaiting_customer_registration_payment_title')
        message = t('awaiting_customer_registration_payment_message')
        Icon = IconWarning
    }else{
        return null;
    }

    return <ImportantMessagesContainer status={employee.status}>
        <div className="message-wrapper">
            <div className="icon-box">
                <Icon/>
            </div>
            <div className="message">
                <h1>{title}</h1>
                <p>{message}</p>
            </div>

        </div>
        {buttonLabel && buttonHandler && (
            <SecondaryButton className="message-action" onClick={buttonHandler}>{buttonLabel}</SecondaryButton>
        )}
        {
            employee.status === EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE &&
            <ResendSignatureEmail employee={employee}/>
        }
    </ImportantMessagesContainer>
}

export default ImportantMessage;
